module.exports = __webpack_public_path__ + "img/orange_circle.c5726492.svg";